/**
 * Converts a camelCase string to a capitalized string with proper spacing.
 * Handles edge cases like consecutive uppercase letters (acronyms) and empty strings.
 *
 * @example
 * camelToCapitalize('') => ''
 * camelToCapitalize('camelCase') => 'Camel Case'
 * camelToCapitalize('XMLHttpRequest') => 'XML Http Request'
 * camelToCapitalize('iOS') => 'i OS'
 * camelToCapitalize('myAPIKey') => 'My API Key'
 */
export default function camelToCapitalize(str) {
    // Handle empty string
    if (!str)
        return '';
    // Insert spaces between:
    // 1. A lowercase letter followed by an uppercase letter (camelCase)
    // 2. An uppercase letter followed by another uppercase letter and then a lowercase letter (acronyms)
    const spaced = str
        .replace(/([a-z])([A-Z])/g, '$1 $2') // camelCase -> camel Case
        .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2'); // XMLHttpRequest -> XML HttpRequest
    // Capitalize the first letter and return
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
